import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { websiteImages } from '../config/images';
import { ChefHat, Heart, Award } from 'lucide-react';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Crimson Text', serif" }}>
            {t.about_title}
          </h2>
          <p className="text-xl text-[#d4af37]">
            {t.about_subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4 col-span-2">
              <img 
                src={websiteImages.about[0].url} 
                alt={websiteImages.about[0].alt}
                className="w-full h-96 object-cover rounded-2xl shadow-2xl border-4 border-[#d4af37]/30 hover:border-[#d4af37] transition-all duration-300"
              />
            </div>
            <div>
              <img 
                src={websiteImages.about[1].url} 
                alt={websiteImages.about[1].alt}
                className="w-full h-48 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <img 
                src={websiteImages.about[2].url} 
                alt={websiteImages.about[2].alt}
                className="w-full h-48 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8">
            <div>
              <p className="text-white/90 text-lg leading-relaxed mb-6">
                {t.about_text_1}
              </p>
              <p className="text-white/90 text-lg leading-relaxed mb-6">
                {t.about_text_2}
              </p>
              <p className="text-white/90 text-lg leading-relaxed">
                {t.about_text_3}
              </p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
                <ChefHat className="w-12 h-12 text-[#d4af37] mx-auto mb-3" />
                <h4 className="text-white font-semibold mb-2">
                  {language === 'de' ? 'Hausgemacht' : language === 'en' ? 'Homemade' : 'Ev Yapımı'}
                </h4>
                <p className="text-white/70 text-sm">
                  {language === 'de' ? 'Täglich frisch' : language === 'en' ? 'Daily fresh' : 'Her gün taze'}
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
                <Heart className="w-12 h-12 text-[#d4af37] mx-auto mb-3" />
                <h4 className="text-white font-semibold mb-2">
                  {language === 'de' ? 'Traditionell' : language === 'en' ? 'Traditional' : 'Geleneksel'}
                </h4>
                <p className="text-white/70 text-sm">
                  {language === 'de' ? 'Originalrezepte' : language === 'en' ? 'Original recipes' : 'Orijinal tarifler'}
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
                <Award className="w-12 h-12 text-[#d4af37] mx-auto mb-3" />
                <h4 className="text-white font-semibold mb-2">
                  {language === 'de' ? 'Qualität' : language === 'en' ? 'Quality' : 'Kalite'}
                </h4>
                <p className="text-white/70 text-sm">
                  {language === 'de' ? 'Beste Zutaten' : language === 'en' ? 'Best ingredients' : 'En iyi malzemeler'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
